import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MessageCircle, X } from 'lucide-react';

const FloatingChatButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tooltip, setTooltip] = useState(false);

  // Hide on chat page and public pages
  if (location.pathname === '/chat' || location.pathname.startsWith('/shared/')) return null;

  const caseMatch = location.pathname.match(/\/cases\/(.+)/);
  const caseId = caseMatch ? caseMatch[1] : null;

  const handleClick = () => {
    // `case_id`, pas `case` : c'est le paramètre que LegalChat lit
    // (pages/LegalChat.js). Avec `case`, le bouton flottant ouvrait un
    // chat vierge depuis une page de dossier — le contexte était perdu
    // sans le moindre signe.
    const url = caseId ? `/chat?case_id=${caseId}` : '/chat';
    navigate(url);
  };

  return (
    <div className="fixed bottom-6 right-6 z-40" data-testid="floating-chat-btn">
      {tooltip && (
        <div className="absolute bottom-16 right-0 bg-[#1a56db] text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap shadow-lg">
          Ask Archer a legal question
        </div>
      )}
      <button
        onClick={handleClick}
        onMouseEnter={() => setTooltip(true)}
        onMouseLeave={() => setTooltip(false)}
        className="w-14 h-14 rounded-full bg-[#1a56db] text-white shadow-lg hover:bg-[#1e40af] flex items-center justify-center transition-all hover:scale-105 active:scale-95"
        aria-label="Ask Archer"
      >
        <span className="text-lg font-bold">A</span>
      </button>
    </div>
  );
};

export default FloatingChatButton;
